import { ReturnTableInputSchema } from "@redotech/redo-return-core-common/returns/return-table-input-schema";
import * as z from "zod";

export const getReturnsCount = {
  name: "getReturnsCount" as const,
  input: ReturnTableInputSchema,
  output: z.object({ total: z.number() }),
};
